import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollContainer = this.element.closest('[id*="messages"]')
    this.userHasScrolled = false
    this.scrollToBottom()
  }

  scrollToBottom() {
    if (!this.userHasScrolled) {
      this.scrollContainer.scrollTop = this.scrollContainer.scrollHeight
    }
  }

  trackUserScroll() {
    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer
    this.userHasScrolled = (scrollHeight - scrollTop - clientHeight) > 10
  }
}
